import { getFirestore, collection, doc, setDoc } from 'firebase/firestore';

export const initializeDatabase = async () => {
  const firestore = getFirestore();
  
  // Create base collections with a placeholder document to ensure they exist
  const collections = [
    'workspaces',
    'workspaceUsers',
    'activities',
    'assignees',
    'statuses',
    'workstreamTypes',
    'workstreams'
  ];

  for (const collectionName of collections) {
    const collRef = collection(firestore, collectionName);
    const placeholderDoc = doc(collRef, '_placeholder');
    try {
      await setDoc(placeholderDoc, {
        _isPlaceholder: true,
        createdAt: new Date().toISOString()
      }, { merge: true });
    } catch (error) {
      console.warn(`Failed to create placeholder for ${collectionName}:`, error);
    }
  }
};